import getIn from 'transmute/getIn';
import { CURRENT_OWNER } from '../constants/KeyPaths';
const getCurrentOwnerAsyncData = getIn(CURRENT_OWNER); // Type for OwnerRecord does not exist yet

export default getCurrentOwnerAsyncData;